// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"UserPage_pageContainer__2Bh7I","columns":"UserPage_columns__Hv-Cp","content":"UserPage_content__zGOjI"};